// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixData from 'wix-data';
$w.onReady(function () {
	//TODO: write your page related code here...
});

export function generateSpaProductButton_click(event) {
// Input data from text boxes saved in array 
    let toSave = {
      "Product Description": $w('#spaProductsDescriptionInput').value,
      "Price": $w('#spaProductPriceInput').value,
      "Duration": $w('#spaProductDurationInput').value,
      "Product Name": $w('#spaProductTitleInput').value
    };

//Save input data to DB
    wixData.save("spaProducts", toSave); 
}